import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    fontSize: "37px",
    color: (props) =>
      props.color == "secondary"
        ? theme.palette.secondary.main + " !important"
        : theme.palette.primary.dark + " !important", // Stupid with important, but desktop has overrides :/
    fontWeight: 300,
    lineHeight: "1.1em",
    marginBottom: (props) => (props.disableMargins ? 0 : theme.spacing(4)),
    marginTop: (props) => (props.disableMargins ? 0 : theme.spacing(2)),
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
    // Custom "break point"
    /* FIXME, not working:
    [theme.breakpoints.up(700)]: {
      fontSize: '35px'
    }*/
  },
}));

const BoxHeading = ({ children, className, ...props }) => {
  const classes = useStyles(props);

  let classesRoot = classes.root;
  if (className) {
    classesRoot += " " + className;
  }

  return (
    <h1 className={classesRoot} {...props}>
      {children}
    </h1>
  );
};

export default BoxHeading;
